<div class="PGDateInterval">
    <button class="btn btn-outline-primary" (click)="openModal()">{{getFormattedValue()}}</button>
</div>

<ng-template #modalPicker>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-date-interval.modal-title' | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
    </div>
    <div class="modal-body">
        @for (month of months; track month) {
            <div class="PGDateInterval-Month">
                <h4 class="text-center my-2">{{getMonthName(month.num)}} {{month.year}}</h4>
                <div>
                    @for (week of month.weeks; track week) {
                        <div class="PGDateInterval-Month-Week">
                            @for (day of week; track day) {
                                <div class="PGDateInterval-Month-Weeks-Day text-center">
                                    @if (day != null) {
                                        <button [disabled]="day.disabled" class="btn my-1 mx-auto {{day.selected ? 'bg-primary text-white' : ''}}" (click)="onDayClick(month.year, month.num, day.num)">
                                            <div class="PGDateInterval-Month-Weeks-Day-Highlight rounded-circle {{day.highlighted ? 'bg-primary' : ''}}"></div>
                                            <div class="PGDateInterval-Month-Weeks-Day-Number {{day.selected || day.highlighted ? 'text-white' : ''}}">{{day.num}}</div>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        <div>
            <button class="btn btn-link btn-block" (click)="addMonth()">
                <i class="fa-regular fa-chevron-down"></i>
            </button>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="clearSelection()">
            {{ 'pg-date-interval.modal-button-clear' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="closeModal()">
            {{ 'pg-date-interval.modal-button-select' | locTranslate }}
        </button>
    </div>
</ng-template>
